import { IRoutingService, Param_Company, Param_NavUrl } from '@common/services/autoresolveservice';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { INavUrlInfo } from '../nav';
import { CompatibilityService } from '@common/services/compatibilityservice';

export class RoutingService implements IRoutingService {
    static $inject = ["CompatibilityService", "$location", "$rootScope"];
    constructor(private readonly $c: CompatibilityService, private readonly $location: ng.ILocationService, $rootScope: ng.IRootScopeService) {
        var r = new BehaviorSubject<string>(null);
        $rootScope.$on("$routeChangeSuccess", (e, newRoute: ng.route.IRoute) => r.next($location.path()));

        this.CurrentRoute = r.pipe(filter(s => s !== null));

        let origSearch = this.search(),
            origNavUrl = origSearch[Param_NavUrl],
            origCompany = origSearch[Param_Company];

        // re- attach navUrl, company, sspUrl Parameter(s) on route Change
        $rootScope.$on("locationChangeSuccess", () => {

            if (this._reloadLocked > 0)
                return;
            let needReload = false,
                checkSearch = this.search();

            let searchNavUrl = checkSearch[Param_NavUrl];
            if (!searchNavUrl && origNavUrl)
                this.search(Param_NavUrl, origNavUrl);
            else if ("" + searchNavUrl !== "" + origNavUrl) { // Allowed????
                needReload = true;
            }

            let searchCompany = checkSearch[Param_Company];
            if (!searchCompany && origCompany)
                this.search(Param_Company, origCompany);
            else if ("" + searchCompany !== "" + origCompany) {
                needReload = true;
            }

            if (needReload) {
                window["_NavReload"] = true;
                window.location.reload(true);
                window.setTimeout(() => { delete window["_NavReload"]; }, 2000);
            }
        });
    }

    /** Promise to Set Current Mandant; CAUTION : Reload necessary after success if already initialized */
    SetCurrentNavContext(toSet: INavUrlInfo, defaultUrl: INavUrlInfo, lockReload: boolean) {
        // Wrap in LockReload if desired
        if (lockReload) {
            this.LockReload(() => {
                this.SetCurrentNavContext(toSet, defaultUrl, false);
            });
            return;
        }

        // per Nav URl!!!
        if (!defaultUrl || toSet.BaseUrl.toLowerCase() !== defaultUrl.BaseUrl.toLowerCase()) {
            // Non Default DB
            this.search(Param_NavUrl, toSet.FullUrl);
            this.search(Param_Company, undefined);
        } else if (defaultUrl && toSet.Mandant !== defaultUrl.Mandant) {
            // Default DB, non default Company
            this.search(Param_NavUrl, undefined);
            this.search(Param_Company, toSet.Mandant);

            // DefaultCompanyAccess.set(currentCompany);
        } else {
            // all Default
            // DefaultCompanyAccess.set(undefined);
            this.search(Param_NavUrl, undefined);
            this.search(Param_Company, undefined);
        }
    }

    public LockReload(action: () => any) {
        this._reloadLocked++;
        try {
            var result = action();
        } catch (err) {
            this._reloadLocked--;
            throw err;
        }
        return this.$c.finally(this.$c.when(result), () => this._reloadLocked--);
    }
    private _reloadLocked = 0;

    get CurrentUrl() { return this.$location.url(); }

    get IsDlg() {
        const s = this.$location.search();
        var isDlg = s && s["IsDlg"];
        return !!isDlg && (isDlg != "0" && isDlg != "false");
    }

    Search(name?: string) {
        if (name == undefined) {
            return this.$location.search();
        }
        var search = this.$location["$$search"];
        return search ? search[name] : undefined;
    }

    path(url: string) {
        this.$location.path(url);
        return this;
    }

    search(...args: any[]) {
        this.$location.search.call(this.$location, ...args);
        return this;
    }

    public readonly CurrentRoute: Observable<string>;
}
